module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.cecdeb26.webp";